import React from 'react'

export default function Unauthorized() {
  return (
    <div>
      <br />
      <br />
      <br />
      <br />
      <h3>
        {" "}
        <center> Unauthorized Access </center>{" "}
      </h3>
      <br />
   <h3>   <center> You do not have permission to view this page.</center> </h3>
      <br />
      <br />
      <br />
      <br />
    </div>
  );
}
